import { render, staticRenderFns } from "./RecoverySuccess.vue?vue&type=template&id=009dd86f"
import script from "./RecoverySuccess.vue?vue&type=script&lang=js"
export * from "./RecoverySuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports